<script>
import { onMounted, computed } from '@vue/composition-api'
import ClassBtn from './ClassBtn.vue'
import getCountDown from './countdown'
import { formatTime } from '@/utils/time'
export default {
  name: 'CountDown',
  components: {
    ClassBtn
  },
  props: {
    event: Object
  },
  setup(props, { root, refs, emit }) {
    // 显示时长为生产平台实际配置时长单位秒+3s反馈时长
    const { realCountdown, start } = getCountDown()
    const countdownDesc = computed(() => formatTime(realCountdown.value, 'mm<i>:</i>ss'))
    function realEnd() {
      emit('realEnd')
    }
    function end() {
      emit('end')
    }
    onMounted(() => {
      // 倒计时互动不添加2s的反馈
      start(props.event.params.duration, () => {
        // 倒计时结束
      })
    })
    return {
      countdownDesc,
      realEnd,
      end
    }
  }
}
</script>
<template>
  <div class="count-down">
    <i class="icon" />
    <p class="normal-que-count count-time" v-html="countdownDesc" />
    <ClassBtn :is-extra-time="false" @realEnd="realEnd" @end="end" />
  </div>
</template>
<style lang="less">
.normal-que-count {
  i {
    font-style: normal;
    padding: 0 6px;
  }
}
</style>
<style lang="less" scoped>
.count-down {
  position: absolute;
  z-index: 2;
  bottom: 40px;
  right: 40px;
  height: 72px;
  background: rgba(36, 39, 49, 0.8);
  border-radius: 29px 16px 16px 0px;
  color: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px 0 58px;
  .icon {
    display: block;
    width: 100px;
    height: 100px;
    background: url("../images/countdown.png") center no-repeat;
    background-size: auto 100%;
    position: absolute;
    top: -14px;
    left: -48px;
  }
}
.count-time {
  width: 110px;
  font-size: 28px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-right: -16px;
}
</style>
